import { render, staticRenderFns } from "./formGroup.vue?vue&type=template&id=226bcafe&"
import script from "./formGroup.vue?vue&type=script&lang=js&"
export * from "./formGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports